import { styled, Link as MuiLink, LinkProps } from '@mui/material';

export const Link = styled((props: LinkProps) => <MuiLink target="_blank" {...props} />)(({ theme }) => ({
  color: theme.palette.primary[600],
  textDecoration: 'none',
  cursor: 'pointer',
}));
